/**
 * CLA Maison — routed succesmelding op de wachtwoordpagina
 * ---------------------------------------------------------------------------
 * WAAROM DIT BESTAAT
 * Het nieuwsbriefformulier op /password draagt `return_to` zodat een bezoeker
 * na verzenden op zijn eigen taalpad terugkomt (/de/password, /fr/password,
 * ...). Die expliciete return_to vervangt Shopify's standaardredirect, en
 * daarmee verdwijnt de enige drager van `customer_posted=true`. Op de echte
 * storefront gemeten: na verzenden landt de bezoeker op
 *
 *   https://clamaison.com/de/password#ClaPasswordNewsletter-<section.id>
 *
 * met het formulieranker maar zonder querystring. `form.posted_successfully?`
 * is daar dus onwaar en de bezoeker kreeg een leeg formulier terug.
 *
 * Dit script is het vangnet voor precies dat geval. Zelfde contract als
 * assets/cla-site-footer.js voor de footer-nieuwsbrief -- hier alleen die ene
 * functie, zonder de footercontroller zelf (die hangt aan .cla-news,
 * [data-cla-news-routed], disclosure-groepen en de cookieknop, geen van alle
 * aanwezig op deze pagina).
 *
 * WAT DE MARKER BEWIJST
 * Dat DEZE tab DIT formulier heeft verzonden en op een door Shopify geleverde
 * URL is teruggekeerd -- NIET dat de server de inschrijving heeft aanvaard.
 * Vandaar dat de onthulde tekst de bestaande, voorwaardelijke copy is
 * ("Als bevestiging nodig is, ontvang je een e-mail ...") en geen claim als
 * "Inschrijving gelukt".
 *
 * NATIVE GAAT ALTIJD VOOR
 * Het routed-element bestaat alleen in de {%- else -%}-tak van de sectie.
 * Rendert Shopify wél een native succes- of foutstatus, dan staat dit element
 * niet in de DOM en kan dit script er per definitie niets overheen zetten.
 *
 * GEEN CSS
 * .cla-password__note heeft geen eigen display-regel, dus de user-agent-regel
 * [hidden]{display:none} doet hier gewoon zijn werk. De rest van het
 * formulier blijft staan: dat is exact hoe de native successtatus er ook
 * uitziet (input en knop blijven zichtbaar, de melding komt eronder).
 *
 * RAAKT DE WACHTWOORDMODAL NIET
 * Alles hieronder blijft binnen form.cla-password__form, dat in de DOM vóór
 * en buiten <password-modal> staat. Geen <details>, geen <summary>, geen
 * button[type="button"], geen [tabindex="-1"], geen wachtwoordveld.
 */
(function () {
  'use strict';

  /* Sleutel en houdbaarheid. 300s dekt ook een trage captcha-afhandeling,
     terwijl het venster waarin een handmatig geopende URL nog een onterechte
     melding zou kunnen opleveren kort blijft. */
  var KEY = 'cla_pw_news_submit';
  var TTL = 300000;

  function readMarker() {
    try {
      return window.sessionStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function dropMarker() {
    try {
      window.sessionStorage.removeItem(KEY);
    } catch (e) {
      /* Werkte opslag al niet, dan viel er ook niets op te ruimen. */
    }
  }

  /* Observeert alleen. Geen preventDefault, geen retourwaarde, geen mutatie
     van het event: de browser vervolgt de verzending ongestoord. Enter en de
     knop vuren hetzelfde submit-event op hetzelfde formulier. */
  function markSubmit(formId) {
    try {
      window.sessionStorage.setItem(
        KEY,
        JSON.stringify({ k: formId, t: Date.now() })
      );
    } catch (e) {
      /* Geen marker: de bezoeker krijgt na terugkeer gewoon het formulier
         terug, precies zoals zonder dit script. */
    }
  }

  /* Geeft alleen true wanneer ALLE factoren kloppen, en consumeert dan
     meteen -- zodat refresh, back/forward en een herstel uit de bfcache de
     melding nooit een tweede keer kunnen tonen. */
  function consumeMarker(formId) {
    var raw = readMarker();
    if (!raw) return false;

    var mark = null;
    try {
      mark = JSON.parse(raw);
    } catch (e) {
      mark = null;
    }

    var usable =
      mark &&
      mark.k === formId &&
      typeof mark.t === 'number' &&
      isFinite(mark.t) &&
      Date.now() - mark.t >= 0 &&
      Date.now() - mark.t <= TTL;

    if (!usable) {
      /* Onbruikbaar of verlopen: opruimen en niets tonen. */
      dropMarker();
      return false;
    }

    /* Tweede factor. Klopt het anker niet, dan blijft de marker staan: de
       bezoeker kan nog altijd op de juiste URL terechtkomen. */
    if (window.location.hash !== '#' + formId) return false;

    dropMarker();
    return true;
  }

  function init() {
    var form = document.querySelector('form.cla-password__form');
    if (!form || !form.id) return;

    /* Bestaat dit element niet, dan rendert Shopify een native succes- of
       foutstatus en heeft dit script hier niets te zoeken. */
    var routed = form.querySelector('[data-cla-pw-routed]');
    if (!routed) return;

    var formId = form.id;

    form.addEventListener('submit', function () {
      markSubmit(formId);
    });

    if (consumeMarker(formId)) {
      /* role="status" staat al in de markup; het element wordt pas hier
         onthuld, dus het is een echte statuswijziging en geen lege live
         region die bij elke render meeschuift. Focus wordt bewust niet
         verplaatst: de bezoeker staat mogelijk al bij de wachtwoordmodal. */
      routed.hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
